import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface StatCardProps {
  readonly label: string
  readonly value: string
  readonly hint?: string
  readonly icon?: LucideIcon
  readonly className?: string
}

/**
 * Cartão de métrica (rótulo em maiúsculas + valor grande + dica opcional). Compartilhado entre o
 * Dashboard e o Analytics — todo valor mapeia um número real (nunca decorativo).
 */
export function StatCard({ label, value, hint, icon: Icon, className }: StatCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border-default bg-background-elevated p-4',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wide text-foreground-muted">{label}</p>
        {Icon !== undefined ? (
          <Icon aria-hidden="true" className="h-4 w-4 shrink-0 text-foreground-muted" />
        ) : null}
      </div>
      <p className="mt-1 text-2xl font-semibold text-foreground-primary">{value}</p>
      {hint !== undefined ? <p className="mt-1 text-xs text-foreground-muted">{hint}</p> : null}
    </div>
  )
}
